import 'css-chunksrc/client/pages/personalSpacePage/styles.scss';export default {
  "planzone": "_planzone_ccvel_1",
  "header": "_header_ccvel_9",
  "profileNavigation": "_profileNavigation_ccvel_21",
  "main": "_main_ccvel_31"
};